import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { Discount } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface DiscontsProps {
    data?: Discount[];
    style?: CSSProperties;
}

export const Discounts: FC<DiscontsProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                Volume and commitment-based discounts
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column title="Discount Type" dataIndex="discountType" width={334} />
                <Column title="Negotiable Offer" dataIndex="offer" width={334} />
                <Column title="Estimated Cost Savings Potential" dataIndex="saving" />
            </Table>
        </div>
    );
};
